import React from "react";
const ServicesCTA = () => <section>hey i'm ServicesCTA</section>;
export default ServicesCTA;
